import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommunicationService } from '../shared/services/communication.service';
//import { CallModel } from '../shared/models/call.model';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnDestroy{
  opened = false;
  commSubsription: Subscription;

  constructor(private commservice : CommunicationService) { 
    this.commSubsription = commservice.tagTransfer.subscribe(data => {
      
      console.log("HomeComponent : tagTransfer : " + data);
      this.opened = data;
    });
  }

  ngOnDestroy()
  {
    console.log("ngOnDestroy : HomeComponent ");
    if( this.commSubsription) {
      this.commSubsription.unsubscribe();
      this.commSubsription = null;
    } 
  }
  /*
  changeData(changedData){
    this.data = changedData;

    console.log("changeData : " + changedData);
  }*/

    afterChangeSidebar(data : boolean)
    {
        this.opened = data;
    }
}
